import { useEffect, useState } from 'react';
import { supabase } from '../../supabase';
import { runAfterAuthHandoff } from '../../ui/splash/authHandoffHold';

/**
 * Resolves the signed-in user's profiles.full_name once per sign-in. Used by
 * AuthContext as a single source of truth for "logged by …" surfaces, so any
 * consumer can read it from context without its own fetch + layout shift.
 * Stays null on failure / missing profile — consumers should hide their
 * surface (or fall back) rather than render a placeholder.
 */
export default function useSessionFullName(sessionUserId) {
  const [sessionFullName, setSessionFullName] = useState(null);

  useEffect(() => {
    if (!sessionUserId) { setSessionFullName(null); return undefined; }
    let cancelled = false;
    // Cosmetic ("logged by …"): waits out a sign-in handoff (authHandoffHold.js).
    const cancelDeferred = runAfterAuthHandoff(() => { void (async () => {
        try {
          const { data } = await supabase
            .from('profiles')
            .select('full_name')
            .eq('id', sessionUserId)
            .maybeSingle();
          if (!cancelled) setSessionFullName(data?.full_name?.trim() || null);
        } catch (_) { /* keep null */ }
    })(); });
    return () => { cancelled = true; cancelDeferred(); };
  }, [sessionUserId]);

  return sessionFullName;
}
